import React from "react";
import { Debug } from "@sonder/editor/source/core/components/Editor/Debug";
import { DraftEditor } from "@sonder/editor/source/core/components/Editor/DraftEditor";
import { ExternalStateBridge } from "@sonder/editor/source/core/components/Editor/ExternalStateBridge";
import { GlobalStyle } from "@sonder/editor/source/core/components/Editor/GlobalStyle";
import { Wrapper } from "@sonder/editor/source/core/components/Editor/Wrapper";
import { Toolbar } from "@sonder/editor/source/core/components/Toolbar";
import { ENABLE_INCOMPLETE_FEATURES } from "@sonder/editor/source/core/constants";
import { getInitialEditorState } from "@sonder/editor/source/core/helpers";
import {
  EditorStoreProvider,
  SearchTermStoreProvider,
  defaultSearchTermState,
} from "@sonder/editor/source/core/stores";
import { EditorProps } from "@sonder/editor/typings/editor";

export const Editor = ({
  className,
  readOnly = false,
  children,
  disabled = false,
  htmlBody,
  placeholder,
  plainBody,
}: EditorProps) => (
  <EditorStoreProvider
    initialState={getInitialEditorState({ htmlBody, plainBody })}
  >
    <SearchTermStoreProvider initialState={defaultSearchTermState}>
      <Wrapper className={className}>
        <GlobalStyle />
        <DraftEditor
          disabled={disabled}
          placeholder={placeholder}
          readOnly={readOnly}
        />
        {ENABLE_INCOMPLETE_FEATURES && <Toolbar />}
      </Wrapper>
      <Debug />
      <ExternalStateBridge>{children}</ExternalStateBridge>
    </SearchTermStoreProvider>
  </EditorStoreProvider>
);
